module.exports = __webpack_public_path__ + "static/media/JobTemplateIcon.b22cc542.png";